// extracted by mini-css-extract-plugin
export var dropdown = "_fi-0";
export var imagePlaceholder = "_fi-2";
export var imageWrapper = "_fi-3";
export var productImage = "_fi-1";
export var truncateContainer = "_fi-4";
export var truncateText = "_fi-5";